import Link from '@ui/components/Link/Link';
import config from '@utils/config';

type MobileMenuTitleProps = {
  slug?: string | null | undefined;
  title?: string;
  showAllTitle: string;
  onClick?: () => void;
};

const MobileMenuTitle = ({
  slug,
  title,
  onClick,
  showAllTitle,
}: MobileMenuTitleProps) => {
  const { locale } = config;
  if (slug) {
    return (
      <div className="py-4.5 flex w-full items-center justify-between px-4">
        <Link
          locale={locale}
          href={slug}
          onClick={onClick}
          className="text-sm font-medium">
          {title}
        </Link>
        <Link locale={locale} href={slug || ''} onClick={onClick}>
          {showAllTitle}
        </Link>
      </div>
    );
  }

  return (
    <div className="py-4.5 flex w-full items-center px-4">
      <span className="text-sm font-medium">{title}</span>
    </div>
  );
};

MobileMenuTitle.displayName = 'MobileMenuTitle';

export default MobileMenuTitle;
